import {User} from '../../incase-domain/user';
import {AppState} from '../reducer';

export const loggedInUserSelector = (state: AppState): User | undefined => state.authReducer.loggedInUser;
